import React, { useState, useEffect } from 'react';
import {
    AppUtils, //@ts-ignore
    Services,
} from '@gscope-mfe/app-bridge';
import {
    MaterialUiCore,
    // @ts-ignore
} from '@gscope-mfe/common-libs';
//import { GetHistory, StartDownload,GetDownloadAll } from './services';
//import {DownloadAll} from '../util'
const { Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Tab, Tabs, Box } =
    MaterialUiCore;
import CloseIcon from '@mui/icons-material/Close';
import DownloadHistory from './DownloadHistory';
import FilesToDownload from './FilesToDownload';
import classes from './DownloadFrameworkCss.module.css';
import moment from 'moment-timezone';
const { GetHistory, StartDownload, GetDownloadAll, StartFileGenerate } = Services;
import Loader from '../../Loader';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
};

const DownloadFramework = ({ setShowDownloadFramework, showDownloadFramework, filters, service, serviceAction }) => {
    const { userInfo } = AppUtils.get();
    const requestor = userInfo.loggedInUserName;
    const [downloadHistory, setDownloadHistory] = useState([]);
    const [selectedTab, setSelectedTab] = useState('files_to_download');
    const [downloadingTransactionId, setDownloadingTransactionId] = useState([]);
    const [loading, setloading] = useState(false);

    const tabs = [
        { id: 'files_to_download', label: 'Files(s) to Download', visible: true },
        { id: 'download_history', label: 'Download History', visible: true },
    ];

    useEffect(() => {
        fetchDownloadhistory();

        const interval = setInterval(() => {
            fetchDownloadhistory();
        }, 20000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const fetchDownloadhistory = async () => {
        try {
            setloading(true);
            const response = await GetHistory(requestor);
            if (response?.data?.status === 'OK' && response?.data?.payload) {
                const downloadHistoryList = response?.data?.payload?.downloadHistory;
                setDownloadHistory(downloadHistoryList);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setloading(false);
        }
    };

    const onTabChange = (event, value) => {
        setSelectedTab(value);
    };

    const formatTime = (dt = '', format = '') => {
        if (!dt) return '';
        if (format === 'date') {
            return moment(dt).format('LL');
        }
        if (format === 'time') {
            return moment(dt).format('LT z');
        }
        return moment(dt).format('MMM-DD-YYYY hh:mm:ss a z');
    };

    const startDownloadFile = async (transactionId, fileName = 'Bulk Download') => {
        try {
            setDownloadingTransactionId((prev) => [...prev, transactionId]);
            const payload = {};
            const response = await StartDownload(transactionId, payload);
            const Name = fileName + '.xlsx';
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', Name);
                link.download = Name;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        } catch (err) {
            console.error('Error in downloading all data', err);
        } finally {
            setDownloadingTransactionId((prev) => prev?.filter((item) => item !== transactionId));
        }
    };

    const startFileGeneration = async (fileName) => {
        try {
            setloading(true);
            const payload = {
                service,
                serviceAction,
                filters,
                description: fileName,
            };
            const response = await StartFileGenerate({ payload: JSON.stringify(payload) });
            if (response?.status === 200 && response?.data?.status === 'ACCEPTED') {
                console.log('Started file generation');
            }
        } catch (error) {
            console.error('Error in file generation', error);
        } finally {
            fetchDownloadhistory();
            setloading(false);
        }
    };

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: '1540px',
                        height: '900px',
                    },
                }}
                open={showDownloadFramework}
                onClose={() => setShowDownloadFramework(false)}
            >
                <Loader show={loading} />
                <DialogTitle>
                    <div className={classes.spaceBetween}>
                        <Typography variant="h5" data-testid="Download-Title" className={classes.bold}>
                            Download
                        </Typography>
                        <CloseIcon onClick={() => setShowDownloadFramework(false)} data-testid="cross-icon" />
                    </div>
                </DialogTitle>
                <Divider></Divider>
                <DialogContent className={classes.zeroHorizontalPadding}>
                    <Grid container className={classes.tabsGrid}>
                        <Tabs
                            TabIndicatorProps={{ style: { backgroundColor: '#0071dc' } }}
                            className={classes.fullWidth}
                            value={selectedTab}
                            onChange={onTabChange}
                            variant="fullWidth"
                        >
                            {tabs
                                .filter((tab) => tab.visible)
                                .map((tab) => (
                                    <Tab
                                        key={tab.id}
                                        data-testid={tab.id}
                                        value={tab.id}
                                        label={tab.label}
                                        id={tab.id}
                                    />
                                ))}
                        </Tabs>
                    </Grid>
                    <TabPanel value={selectedTab} index="files_to_download">
                        <FilesToDownload
                            downloadHistory={downloadHistory}
                            downloadingTransactionId={downloadingTransactionId}
                            showTableHead={false}
                            startDownloadFile={startDownloadFile}
                            formatTime={formatTime}
                            startFileGeneration={startFileGeneration}
                            setSelectedTab={setSelectedTab}
                            fetchDownloadhistory={fetchDownloadhistory}
                        />
                    </TabPanel>
                    <TabPanel value={selectedTab} index="download_history">
                        <DownloadHistory
                            downloadHistory={downloadHistory}
                            downloadingTransactionId={downloadingTransactionId}
                            showTableHead={true}
                            startDownloadFile={startDownloadFile}
                            formatTime={formatTime}
                        />
                    </TabPanel>
                </DialogContent>
                <Divider></Divider>
                <DialogActions className={classes.TwentyPadding}>
                    <Button
                        data-testid="cancel"
                        onClick={() => setShowDownloadFramework(false)}
                        className={classes.secondaryButton}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DownloadFramework;
